import { ModuleLayout } from "layouts";
import CustomerDetails from "./CustomerDetails";

function CustomerDetailsPage() {
  return (
    <ModuleLayout title="Customer Details">
      <CustomerDetails />
    </ModuleLayout>
  );
}
export default CustomerDetailsPage;
